// extracted by mini-css-extract-plugin
export default {"sparkle":"hMjK1J","eclipseAiHatSparkle":"RWTkaa","text":"OdrdPa","eclipseAiHatShimmer":"ZkwzmE","settled":"JXXULB"};